<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

        <!--<div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo" class="user-image-circle-65px img7">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>
        </div>-->

      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row bordertop5px">
          <div class="col-print-12 text-align-center padding-top-5px">
            <label class="font-familyhead">Item-Wise Breakup(IP)</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.AdmissionNo}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Ward / Room:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{l.BedLocation}} / {{l.CareUnit}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{l.ProviderIncharge}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          
          <div class="row margin-right-0px margin-left-0px" >
            <div class="col-print-12">
              
              <div class="row border4 margin-left-0px margin-right-0px">
                <div class="col-print-2">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Date</label>
                </div>
                <div class="col-print-6">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Item Description</label>
                </div>
                <div class="col-print-1">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Qty</label>
                </div>
                <div class="col-print-1 margin-right-5px">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Price</label>
                </div>
                <div class="col-print-1 margin-right-5px">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Amount</label>
                </div>
                <div class="col-print-1 margin-right-5px">
                  <label class="font-weight-bold margin-bottom-0px background-primary padding-top-2px padding-bottom-2px font-family">Net</label>
                </div>


              </div>

              <div class="row margin-left-0px margin-right-0px" *ngFor="let l of ServiceCategorynames">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-weight-bold background-primary font-family">{{l.ServiceCategoryName}}</label>
                </div>
                <div class="col-print-12">

                  <div class="row margin-left-0px margin-right-0px" *ngFor="let d of GetItems(l.ServiceCategoryName)">
                    <div class="col-print-2">
                      <label class="margin-bottom-0px background-primary font-family">{{d.ItemEntryDate | date:'MMM-dd-yyyy'}}</label>
                    </div>
                    <div class="col-print-6">
                      <label class="margin-bottom-0px background-primary font-family">{{d.ItemDescription}}</label>
                    </div>
                    <div class="col-print-1">
                      <label class="margin-bottom-0px background-primary font-family">{{d.Quantity}}</label>
                    </div>
                    <div class="col-print-1 margin-right-5px">
                      <label class="margin-bottom-0px background-primary font-family">{{d.UnitPrice | number:'1.2-2'}}</label>
                    </div>
                    <div class="col-print-1 margin-right-5px">
                      <label class="margin-bottom-0px background-primary font-family">{{d.ItemTotal | number:'1.2-2'}}</label>
                    </div>
                    <div class="col-print-1 margin-right-5px">
                      <label class="margin-bottom-0px background-primary font-family">{{(d.Quantity * d.UnitPrice)-(d.Quantity * d.UnitPrice * (d.Discount / 100)) | number:'1.2-2'}}</label>
                    </div>


                  </div>
                </div>

                </div>
              </div>
          </div>
          
        </div>


        <div class="col-print-12 border-top-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-10">
              <label class="margin-bottom-0px font-family font-weight-normal">Amount In Words: {{CurrentX_BillHeaderController.Net - CurrentX_BillHeaderController.Balance | amountToWord}}</label>
            </div>
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CurrentX_BillHeaderController.Net - CurrentX_BillHeaderController.Balance | number:'1.2-2'}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal">Cashier:</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <!--<div class="col-print-1">
        <label class="margin-bottom-0px font-family font-weight-bold">(</label>
      </div>-->
            <div class="col-print-5" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <!--<div class="col-print-1">
        <label class="margin-bottom-0px font-family font-weight-bold">)</label>
      </div>-->
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-bold">Due:</label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Due}}</label>
      </div>
    </div>
  </div>-->
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
